@if (selectedItemsArray?.length >= 1) {
<div class="checklist-floater-action-container modal-footter">
  <div class="checklist-floater-action-container-body">
    <div class="checklist-floater-item-container">
      <div class="checklist-floater-item-container-left workspace-left">
        <h1 class="checklist-floater-item-container-left-title">{{ selectedItemsArray?.length }}</h1>
        <p class="checklist-floater-item-container-left-text">
          {{ selectedItemsArray?.length > 1 ? 'Items' : 'Item' }} <br />
          Selected
        </p>
      </div>
      <div class="workspace-right-wrapper">
        <div class="checklist-floater-item-container-body" (click)="deleteSelection()">
          <span class="material-icons checklist-floater-item-container-body-icon" style="color: #eb5757 !important">delete</span>
          <p class="checklist-floater-item-container-body-text" style="color: #eb5757 !important">Delete</p>
        </div>
        @if(selectedItemsArray | uploadFileFilter:'save_enable'){
        <div class="checklist-floater-item-container-right" style="border-left: 1px solid #d3dce8b2" (click)="saveSelection()">
          <span
            class="checklist-floater-item-container-right-line"
            style="background: #25508e !important; z-index: 0; height: 72px; width: 72px; border-radius: 12px"
          ></span>
          <span class="material-icons checklist-floater-item-container-right-closeicon z-[1] text-[#fff]">done</span>
          <p class="checklist-floater-item-container-right-closetext z-[1] text-[#fff]">Save</p>
        </div>
        }@else{
        <div class="checklist-floater-item-container-right" style="border-left: 1px solid #d3dce8b2">
          <span class="checklist-floater-item-container-right-line bg-[#c1c2c5] z-[0] h-[72px] w-[72px] rounded-[12px]"></span>
          <span class="material-icons checklist-floater-item-container-right-closeicon z-[1] text-[#fff]">done</span>
          <p class="checklist-floater-item-container-right-closetext z-[1] text-[#fff]">Save</p>
        </div>

        }

        <div class="checklist-floater-item-container-right" (click)="clearSelection()">
          <span class="checklist-floater-item-container-right-line"></span>
          <span class="material-icons checklist-floater-item-container-right-closeicon">clear</span>
          <p class="checklist-floater-item-container-right-closetext">Close</p>
        </div>
      </div>
    </div>
  </div>
</div>
}
